<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9 12" fill="none">
    <path fill="currentColor" d="M0.5 1.86852C0.5 1.06982 1.39015 0.59343 2.0547 1.03647L8.25192 5.16795C8.84566 5.56377 8.84566 6.43623 8.25192 6.83205L2.0547 10.9635C1.39015 11.4066 0.5 10.9302 0.5 10.1315V1.86852Z" />
  </svg>
</template>